const replaceItem = (arr, index, newItem) => {
  const newArr = arr.slice(0, arr.length);

  newArr.splice(index, 1, newItem);

  return newArr;
};

export default replaceItem;
